
define('text!modules/reporting/campaigns/geoPerformance/templates/layout.html',[],function () { return '<div class="report-chart"></div>\n<div class="report-controls {{#chartHidden}}collapsed{{/chartHidden}}"></div>\n<div class="report-grid"></div>\n';});

